<template>
  <el-dialog
    title="添加权益"
    :visible.sync="visible"
    width="692px"
    @close="handleClose"
    :append-to-body="true"
  >
    <div class="form-wrapper" v-loading="loading">
      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        label-position="left"
        label-width="120px"
      >
        <el-form-item prop="title" label="权益标题">
          <el-input
            v-model="form.title"
            placeholder="请输入"
            maxlength="6"
            :autosize="false"
            v-deleteEmoji
            type="textarea"
          />
        </el-form-item>
        <el-form-item prop="content" label="权益说明">
          <div class="textarea-wrapper">
            <el-input
              :autosize="false"
              v-model="form.content"
              type="textarea"
              v-deleteEmoji
              placeholder="请输入"
              maxlength="50"
            />
          </div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue'
import { checkContentSafety } from '../../hooks/contentSafety'

const emits = defineEmits(['confirm', 'close'])

const visible = ref(false)
const loading = ref(false)
const formRef = ref(null)
const form = ref({
  title: '',
  content: '',
})

const rules = {
  title: [{ required: true, message: '请输入权益标题', trigger: 'blur' }],
  content: [{ required: true, message: '请输入权益说明', trigger: 'blur' }],
}

const handleClose = () => {
  form.value = {
    title: '',
    content: '',
  }
  formRef.value?.clearValidate()
  visible.value = false
}


const handleConfirm = async () => {
  if (loading.value) return
  formRef.value.validate(async (valid) => {
    if (!valid) return

    // 对问题描述和答案描述进行安全验证
    const titleSafe = await checkContentSafety(form.value.title, (isLoading) => {
      loading.value = isLoading
    })
    if (titleSafe === false) {
      // 使用正确的方式设置错误信息
      formRef.value.fields.find((field) => field.prop === 'title').validateMessage = '输入内容中包含不合规信息，请检查修改后重试'
      formRef.value.fields.find((field) => field.prop === 'title').validateState = 'error'
    }

    const contentSafe = await checkContentSafety(form.value.content, (isLoading) => {
      loading.value = isLoading
    })
    if (contentSafe === false) {
      // 使用正确的方式设置错误信息
      formRef.value.fields.find((field) => field.prop === 'content').validateMessage = '输入内容中包含不合规信息，请检查修改后重试'
      formRef.value.fields.find((field) => field.prop === 'content').validateState = 'error'
    }
    if (!titleSafe || !contentSafe) return

    // 验证通过，提交表单
    emits('confirm', { ...form.value, selected: true })
    handleClose()
  })
}

defineExpose({
  open: (editData) => {
    form.value = { ...editData }
    visible.value = true
  },
})
</script>

<style lang="scss" scoped>
.form-wrapper {
  padding: 0 106px;
}

.textarea-wrapper {
  position: relative;
  margin-bottom: 22px; // 为字数限制留出空间
}

::v-deep {
  .el-form-item__label {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
  }
  .textarea-wrapper {
    margin-bottom: 2px;
  }
}
</style>
